import React from 'react';

import { Spinner } from '@/components/ui/spinner';
import CurrentReportsSitrepCard from 'components/Reports/CurrentReportsSitrepCard';
import { ReportsEmptyState } from 'components/Reports/ReportsEmptyState';
import type { GetSitrepsResponse } from 'components/Reports/reports.types';
import { useAorText } from 'utils/aorTerminology';

type CurrentReportViewProps = {
  scopeName: string;
  latestSitreps: Map<string, GetSitrepsResponse>;
  isLoading: boolean;
  isError: boolean;
  derivedAorId?: string | null;
  hasInProgressDraft?: boolean;
};

const CurrentReportView: React.FC<CurrentReportViewProps> = ({
  scopeName,
  latestSitreps,
  isLoading,
  isError,
  derivedAorId,
  hasInProgressDraft = false,
}) => {
  const aorText = useAorText();
  return (
    <div className="reports-tabs tw:pt-3">
      {isError ? (
        <ReportsEmptyState
          icon="error"
          title="Error loading reports"
          description={aorText(
            'Try refreshing or selecting a different AOR or incident.'
          )}
        />
      ) : isLoading ? (
        <Spinner className="tw:size-6" />
      ) : latestSitreps.size > 0 ? (
        Array.from(latestSitreps.values()).map((latestSitrep) => (
          <div key={latestSitrep.id} className="reports-tabs__latest-sitrep">
            <CurrentReportsSitrepCard
              sitrep={latestSitrep}
              hasInProgressDraft={hasInProgressDraft}
            />
          </div>
        ))
      ) : (
        <ReportsEmptyState
          title={`No reports for ${scopeName} yet`}
          description={
            derivedAorId
              ? 'Create a draft report to get started.'
              : aorText(
                  'Unable to determine Area of Responsibility for this incident. Please ensure the incident is associated with an AOR in order to create and view draft SITREPs.'
                )
          }
        />
      )}
    </div>
  );
};

export default CurrentReportView;
